import { EChartsInstance } from 'echarts-for-react';
import GIFEncoder from 'gif-encoder-2';

export const FRAME_DELAY = 500;
export const RENDER_DELAY = 300;
export const GIF_QUALITY = 10;

export const createGifEncoder = (canvas: HTMLCanvasElement) => {
    const encoder = new GIFEncoder(canvas.width, canvas.height);
    encoder.setDelay(FRAME_DELAY);
    encoder.setQuality(GIF_QUALITY);
    encoder.setRepeat(0);
    encoder.start();
    return encoder;
};

export const downloadGif = (encoder: GIFEncoder, filename: string = 'chart_animation.gif') => {
    encoder.finish();
    const blob = new Blob([encoder.out.getData()], { type: 'image/gif' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();

    URL.revokeObjectURL(url);
};

export const getTimelineFrames = (instance: EChartsInstance): number[] => {
    const timeline = instance.getOption()?.timeline?.[0];
    if (!timeline?.labels) return [];

    return timeline.labels.map((_, index) => index).filter((index) => timeline.labels?.[index]);
};

export const animateChartTo = (instance: EChartsInstance, frameIndex: number): void => {
    instance?.dispatchAction({
        type: 'timelineChange',
        currentIndex: frameIndex,
    });
};
